import { render, staticRenderFns } from "./WebhookUrls.vue?vue&type=template&id=40b6551f"
import script from "./WebhookUrls.vue?vue&type=script&lang=js"
export * from "./WebhookUrls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports